import { Button, Grid, Tabs } from '@arco-design/web-react';
import * as React from 'react';

const { Row, Col } = Grid;
const TabPane = Tabs.TabPane;

// MUI Tabs/Tab -> Arco Tabs/Tabs.TabPane. ButtonGroup -> Button.Group; Box/Grid
// -> Arco Grid (xs={8} -> span={16}, xs={12} -> span={24}). The props interface
// (tabs = array of {name, component, disabled}, exports TabViewerBasic/
// TabViewerHorizontal) is preserved exactly.

export function TabViewerHorizontal({ tabs }) {
  const [value, setValue] = React.useState("0");

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{ width: '100%' }}>
      <Tabs activeTab={value} onChange={handleChange}>
        {
          tabs.map((item, index) => (
            <TabPane key={String(index)} title={item.name}>
              <div style={{ padding: 8 }}>{item.component}</div>
            </TabPane>
          ))
        }
      </Tabs>
    </div>
  );
}

export function TabViewerBasic({ tabs, saveChanges }) {
  const [tabStates, setTabStates] = React.useState(tabs.map(() => ({ disabled: true })));

  const handleToggle = (index) => {
    setTabStates((prevStates) => {
      const newStates = prevStates.map((state, i) => ({ disabled: i !== index }));
      return newStates;
    });
  };


  return (
    <Row gutter={16}>

      <Col span={16}>

        <Button.Group>
          {tabs.map((item, index) => (
            <Button
              disabled={!tabStates[index].disabled}
              key={index}
              type="primary"
              onClick={() => handleToggle(index)}
            >
              {item.name}
            </Button>
          ))}
        </Button.Group>
      </Col>


      <Col span={24}>
        {tabs.map((item, index) => (
          <div key={index} hidden={tabStates[index].disabled}>
            {item.component}
          </div>
        ))}
      </Col>


    </Row>
  );
}
